export default __webpack_public_path__ + "4d31d2ccad2b24302503f7342951ce80.png";